import { createI18n } from "vue-i18n";

// Localisation language list
import { locale as tr } from "@/locales/i18n/tr";
import { locale as en } from "@/locales/i18n/en";

let messages = {};
messages = { ...messages, tr, en };

// get current selected language
const lang = localStorage.getItem("language") || "tr";

// Create VueI18n instance with options
const i18n = createI18n({
  legacy: false,
  locale: lang,
  fallbackLocale: "tr", // eksik en anahtarları Türkçe'ye düşer
  globalInjection: true,
  messages,
});

export default i18n;
